import { HttpMethods, makeRequest } from '../helpers/http.helper';

export interface RecyclerPreOrdersOverview {
  total_orders: number;
  total_ordered_kg: number;
  fulfilled_kg: number;
  remaining_kg: number;
  pending_count: number;
  partially_fulfilled_count: number;
  completed_count: number;
  cancelled_count: number;
}

interface RecyclerPreOrdersDashboardResponse {
  organization_id: string;
  total_count: number;
  overview: RecyclerPreOrdersOverview;
}

/** Whole-history totals for a recycler's pre-orders, all in kilograms. */
export async function getRecyclerPreOrdersOverview(organizationId: string): Promise<RecyclerPreOrdersOverview> {
  const response = (await makeRequest({
    url: `/dashboard/recycler/${organizationId}/pre-orders`,
    method: HttpMethods.GET,
    params: {
      start_date: '2000-01-01T00:00:00.000Z',
      end_date: '2100-01-01T00:00:00.000Z',
      offset: 0,
      limit: 1,
    },
  })) as { result: RecyclerPreOrdersDashboardResponse };
  return response.result.overview;
}
